// extracted by mini-css-extract-plugin
export var raisedContainer = "contentBlock-module--raisedContainer--eNpP1";